import * as getSports from './reducers/get';
import { simple } from 'src/utils/reducers';
import { update, bulk as bulkUpdate } from './reducers/update';
import * as moveList from './reducers/move-list';

// eslint-disable-next-line import/no-default-export
export default simple({
    SPORTS_GET_REQUEST: getSports.request,
    SPORTS_GET_ERROR: getSports.error,
    SPORTS_GET_FINISH: getSports.finish,

    SPORTS_DATA: bulkUpdate,
    SPORT_DATA: update,

    SPORTS_LIST_MOVE_REQUEST: moveList.request,
    SPORTS_LIST_MOVE_ERROR: moveList.error,
    SPORTS_LIST_MOVE_FINISH: moveList.finish,
});
